import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
// import Validate from './FormValidation'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Media,
  Col
} from "reactstrap";
import { spinnerService } from "@chevtek/react-spinners";
import { domainToUnicode } from "url";
import { DocumentClient } from "aws-sdk/clients/dynamodb";
function LoginForm(props) {
  return <h1>Hello , {props.name}</h1>;
}
function NewPWDForm(props) {
  return <h1>Hello New PWD Form, {props.name}</h1>;
}

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errors: {
        cognito: null,
        blankfield: false
      },
      error: true
    };
  }

  handleSubmit = async event => {
    event.preventDefault();
    let { password, email } = this.state;
    if (password === "" || password === null)
      document.getElementById("password").focus();
    else if (email === "" || email === null)
      document.getElementById("email").focus();
    else {
      try {
        spinnerService.show("mySpinner");
        /*
        const reguser = await Auth.signUp({
          username: email,
          password,
          attributes: {
            // email: "ali_saify@hotmail.com",
            phone_number: "+923335319372"
          }
        });
        spinnerService.hide("mySpinner");
*/
        email = email.toLowerCase();
        const user = await Auth.signIn(email, password);
        //var person = prompt("Please enter your name", "Harry Potter");
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          const loggedUser = await Auth.completeNewPassword(
            user, // the Cognito User Object
            "123456" // the new password
          );
        }
        if (user) {
          this.props.storeUser(user);
          this.props.history.push("/");
        }
        spinnerService.hide("mySpinner");
      } catch (err) {
        spinnerService.hide("mySpinner");
        this.props.storeUser("notFound");
        toast.error(err.message);
      }
    }
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  render() {
    let { error } = this.state;
    return (
      <div style={{ paddingTop: 20 }}>
        <main ref="main">
          <ToastContainer />
          <section className="section section-shaped section-lg">
            <Container className=" pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="8">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-2 pt-3">
                      <div className="pb-2">
                        <span style={{ fontSize: "30px" }}> Login Here! </span>
                      </div>
                    </CardHeader>

                    <CardBody className="bg-white  px-5 py-5">
                      <Form onSubmit={this.handleSubmit} role="form">
                        <FormGroup>
                          <InputGroup className=" input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>

                            <Input
                              value={this.state.email}
                              id="email"
                              onChange={this.onInputChange}
                              placeholder="Username"
                              type="text"
                              autoComplete="off"
                            />
                          </InputGroup>
                        </FormGroup>

                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText></InputGroupText>
                            </InputGroupAddon>
                            <Input
                              value={this.state.password}
                              id="password"
                              onChange={this.onInputChange}
                              placeholder="Password"
                              type="password"
                              autoComplete="off"
                            />
                          </InputGroup>
                        </FormGroup>

                        <Row className="my-4">
                          <Col xs="12">
                            <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="cbRegister"
                                type="checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="cbRegister"
                              ></label>
                              Remember Me
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="auto">
                            <div>
                              <Button
                                className=""
                                type="submit"
                                color="primary"
                              >
                                Sign In
                              </Button>
                              <span>
                                <Button
                                  className="bg-transparent text-info"
                                  color=""
                                >
                                  <Media to="/forgot-password" tag={Link}>
                                    Forgot Password
                                  </Media>
                                </Button>
                              </span>
                            </div>
                          </Col>
                        </Row>

                        <Row className="my-4">
                          <Col xs="auto">
                            <Media to="/reg/customer" tag={Link}>
                              Resgister as Customer
                            </Media>
                          </Col>
                          ||
                          <Col xs="auto">
                            <Media to="/Inspector-Reg" tag={Link}>
                              Resgister as Inspector or Mechanic
                            </Media>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.config.user
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeUser: data => dispatch(actionTypes.storeUser(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data))
  };
};
export default LoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/Login.js